import IFACE, { EL } from './IFACE.js';
import Translate, { LANGUAGECODE } from '../event/Translate.js';
/** An interface for Translation driven Events */
export default class Translatable extends IFACE {
    /** A series of Translation Related Events and Methods */
    constructor(node) {
        super(node, 'translatable');
        // Add this node to the PAGE's translatable array
        const page = node.getMain();
        if (page && page.data.config?.translation?.translatable) {
            page.data.config.translation.translatable.push(node);
        }
    }
    addListeners(node) {
        node.on('translate', (ev) => {
            const customEv = ev;
            this.translate(node, customEv.detail.language);
        });
    }
    setMethods(node, dur = 150) {
        /** Translate to English */
        this.methods.translate_CA_EN = () => this.translate(node, LANGUAGECODE.CA_EN);
        /** Translate to French */
        this.methods.translate_CA_FR = () => this.translate(node, LANGUAGECODE.CA_FR);
    }
    /** Moves this element in the specified direction amongst its siblings
        @param {EL} node Element to implement methods
        @param {string} languageCode Language Code to translate to
    */
    translate(node, languageCode) {
        let config = node.getMain().getConfig();
        // let languageCode = config.translation.language.code;
        const textGroup = node.data.textGroup;
        const textKey = node.data.textKey;
        // const textGroup = config.translation.text[languageCode][];
        if (textGroup && textKey) {
            const translatedText = node.getMain().getStringByParam(languageCode, textGroup, 'key', textKey);
            if (translatedText) {
                node.setInnerHTML(translatedText);
                node.data.text = translatedText;
            }
            else {
                console.warn(`Translatable: No translated text found for group "${textGroup}" and key "${textKey}" in language "${languageCode}"`);
            }
        }
    }
}
export { EL, IFACE, Translate };
